import { useId } from 'react';

export const BrandMark = ({ className = 'h-8 w-8' }) => {
  const id = `ps-mark-${useId().replace(/:/g, '')}`;
  return (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#2563EB" /><stop offset="1" stopColor="#4F46E5" /></linearGradient></defs>
    <rect width="32" height="32" rx="8" fill={`url(#${id})`} />
    <path d="M10 23V9h7.2a4.6 4.6 0 0 1 0 9.2H10" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 18.2 22.5 23" fill="none" stroke="#fff" strokeOpacity="0.55" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
  );
};

export const Wordmark = ({ collapsed }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-wordmark">
    <BrandMark className="h-8 w-8 shrink-0" />
    {!collapsed && <div className="leading-none">
      <p className="text-[13px] font-semibold tracking-[0.18em] text-white">PRACTICE SUITE</p>
      <p className="mt-1 text-[10px] tracking-[0.08em] text-nav-foreground/70">Tax &amp; Accounting</p>
    </div>}
  </div>
);
